export default "__VITE_ASSET__1ne2JmWl__"